module.exports = __webpack_public_path__ + "static/media/icon-close.c3194f5a.svg";